/* ==========================================================================
   Mirthly — sélecteur de formules (présentation)
   --------------------------------------------------------------------------
   Ce fichier ne fait QUE de la présentation et de la sélection.

   Il ne touche pas au panier, et il ne gère pas le cadeau : mirthly-gift.js
   s'en charge déjà (variante à 0,00 $, réconciliation sur /cart.js, garde
   anti-boucle, window.fetch enveloppé). Ajouter ici une seconde
   synchronisation créerait exactement le mécanisme concurrent qu'il faut
   éviter : deux scripts qui ajoutent et retirent la même ligne finissent par
   se battre, et le client voit son panier bouger tout seul.

   Le prix affiché ne peut pas diverger de celui facturé, parce qu'aucun prix
   n'est calculé ici : tout est rendu par Liquid depuis les variantes Shopify
   (price, compare_at_price), et la sélection est relayée à l'ancien
   sélecteur #tiers, masqué, qui reste le moteur — barre fixe, libellé du
   CTA, variante du formulaire de paiement accéléré, ajout au panier.
   ========================================================================== */
(function () {
  "use strict";

  var RACINE = "[data-mirthly-bundle]";

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* Applique visuellement l'index choisi. Ne touche pas au moteur. */
  function peindre(bloc, index) {
    $$(".mirthly-bundle__card", bloc).forEach(function (carte) {
      var actif = Number(carte.dataset.index) === Number(index);
      carte.classList.toggle("is-selected", actif);
      var radio = $(".mirthly-bundle__input", carte);
      if (radio) radio.checked = actif;
    });
  }

  /* Relaie vers la carte d'origine : mirthly.js y a posé un gestionnaire de
     clic, donc tout le reste se met à jour comme si l'ancien sélecteur avait
     été utilisé. C'est ce qui évite de réimplémenter la tarification. */
  function relayer(index) {
    var origine = document.querySelector('#tiers .tier[data-i="' + index + '"]');
    if (origine) origine.click();
  }

  function indexMoteur() {
    var actif = document.querySelector('#tiers .tier[aria-checked="true"]');
    return actif ? Number(actif.dataset.i) : null;
  }

  /* Libellé du CTA : « Add 2 to cart ».
     mirthly.js réécrit ce texte à chaque rendu et le remplace par « Adding… »
     pendant l'ajout au panier. On ne touche donc qu'au texte, jamais à l'état
     du bouton, on s'abstient tant qu'il est désactivé, et on repasse après
     chaque rendu grâce à l'observateur. */
  function libeller(bloc) {
    var carte = $(".mirthly-bundle__card.is-selected", bloc);
    if (!carte) return;
    var n = carte.dataset.quantity;
    if (!n) return;
    /* Version Noel : « Add to cart » (le prix suit dans le bouton). */
    var lib = bloc.dataset.ctaLabel || "";
    var prix = $(".mirthly-bundle__now", carte);
    ["#cta", "#ctaMobile"].forEach(function (sel) {
      var btn = $(sel);
      if (!btn || btn.disabled) return;
      var span = btn.querySelector("span");
      if (!span) return;
      if (!lib) span.textContent = "Add " + n + " to cart";
      else span.textContent = sel === "#ctaMobile" && prix ? lib + " \u2014 " + prix.textContent : lib;
    });
  }

  function annoncer(bloc, message) {
    var zone = $("[data-mirthly-live]", bloc);
    if (zone && message) zone.textContent = message;
  }

  function brancher(bloc) {
    /* Délégation : un seul écouteur, donc rien à nettoyer si la section est
       rendue à nouveau dans l'éditeur de thème. */
    bloc.addEventListener("change", function (e) {
      var radio = e.target.closest(".mirthly-bundle__input");
      if (!radio) return;
      var index = Number(radio.value);
      peindre(bloc, index);
      relayer(index);
      libeller(bloc);
      annoncer(bloc, radio.dataset.annonce || "");
    });

    /* Ce sont de vrais <input type="radio"> dans des <label> : flèches et
       tabulation fonctionnent déjà. On ajoute Entrée, que le navigateur ne
       traite pas sur un bouton radio. */
    bloc.addEventListener("keydown", function (e) {
      if (e.key !== "Enter") return;
      var carte = e.target.closest(".mirthly-bundle__card");
      if (!carte) return;
      var radio = $(".mirthly-bundle__input", carte);
      if (!radio || radio.checked) return;
      e.preventDefault();
      radio.checked = true;
      radio.dispatchEvent(new Event("change", { bubbles: true }));
    });

    /* L'ancien sélecteur reste la source de vérité : s'il change par un autre
       chemin — les boutons 1/2/3 de la barre fixe — on se réaligne.
       mirthly.js reconstruit #tiers entièrement à chaque rendu, donc on
       surveille childList : un observateur limité aux attributs ne verrait
       jamais rien passer. */
    var tiers = $("#tiers");
    if (tiers && "MutationObserver" in window) {
      new MutationObserver(function () {
        var i = indexMoteur();
        if (i !== null) peindre(bloc, i);
        libeller(bloc);
      }).observe(tiers, { attributes: true, childList: true, subtree: true });
    }
  }

  function init() {
    var bloc = $(RACINE);
    if (!bloc || bloc.dataset.mirthlyReady === "1") return;
    bloc.dataset.mirthlyReady = "1";

    brancher(bloc);

    /* Une variante choisie par l'URL prime : un lien partagé ou une campagne
       qui pointe une formule précise doit être respecté. Sinon on applique la
       formule configurée dans l'éditeur de thème, sans quoi on hériterait
       simplement du premier palier retenu par mirthly.js. */
    var urlVariante = /[?&]variant=/.test(window.location.search);
    var i = indexMoteur();
    if (urlVariante && i !== null) {
      peindre(bloc, i);
      libeller(bloc);
      return;
    }
    var defaut = Number(bloc.dataset.defaultIndex || 0);
    peindre(bloc, defaut);
    if (i !== defaut) relayer(defaut);
    libeller(bloc);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();
